/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import style from './tagsSearch.module.scss';
import cx from 'classnames';
import { useSearchControl } from 'hooks/useSearchControl';
import SearchInput from '../core/searchInput/searchInput';
import SearchOverlay from '../core/searchOverlay/searchOverlay';
import SearchInputContainer from '../core/searchLineContainer/searchLineContainer';
import isFunction from 'lodash-es/isFunction';
import Close from 'icons/close';
import CircleClose from 'icons/circles/circleClose';
import { MIN_TABLET_WIDTH } from 'utils/utils';
import { useViewport } from 'contexts/viewportContext';

export type SearchSection = 'selected' | 'available' | 'create' | 'top';

export type SpecialChipType = 'only_uploaded' | 'only_liked';

export default function TagsSearch({
  isDisabled = false,
  className = '',
  initialSearch = '',
  tagsStrategy,
  onOpenChange,
}: {
  isDisabled?: boolean;
  className?: string;
  initialSearch?: string; // Начальное значение в строке поиска
  tagsStrategy?: typeof useSearchControl;
  onOpenChange: (isOpen: boolean) => void;
}) {
  const { clearAll, search, setSearch } = isFunction(tagsStrategy)
    ? tagsStrategy()
    : useSearchControl();
  const [isOpen, setIsOpen] = useState(false);
  const { width } = useViewport();

  const isMobileAdaptiveModeOn = width <= MIN_TABLET_WIDTH;

  useEffect(() => {
    if (initialSearch) {
      setSearch(initialSearch);
    }
  }, [initialSearch]);

  useEffect(() => {
    onOpenChange(isOpen);
  }, [isOpen]);

  return (
    <>
      <div
        className={cx(
          'searchControlTags',
          style.container,
          className,
          isDisabled ? 'disabled' : '',
          isOpen ? 'isOpen' : ''
        )}
      >
        <SearchOverlay isOpen={isOpen} setIsOpen={setIsOpen}></SearchOverlay>

        <SearchInputContainer isOpen={false}>
          <SearchInput
            setIsOpen={setIsOpen}
            isDisabled={isDisabled}
            setSearch={setSearch}
            search={search}
            placeholder={
              isMobileAdaptiveModeOn
                ? 'Например: #электробус'
                : 'Начните вбивать тег, чтобы найти то, что вам нужно'
            }
          ></SearchInput>
          {search.length ? (
            <CircleClose className={style.close}>
              <Close onClick={() => clearAll()}></Close>
            </CircleClose>
          ) : (
            ''
          )}
        </SearchInputContainer>
      </div>
    </>
  );
}
